import { signIn, SignInAuthorizationParams, SignInOptions } from 'next-auth/react';
import { TreatmentWithConfig } from '@splitsoftware/splitio/types/splitio';
import { setSessionStorageItem } from 'src/services/storage/session';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import { ZILLOW_AUTH_PROVIDER } from 'src/services/auth/constants';
import * as ExperimentService from 'src/services/experiments/ExperimentService.client';
import { FetchClient } from 'src/services/fetch/FetchService.client';
import { noop } from 'src/utils/noop';
import { appendAuth0IdpIdentifier } from '../appendAuth0IdpIdentifier';
import { LOCATION_REQUESTED_SESSION_STORAGE_KEY, SUPPORTED_LOGIN_FLAG, ENABLE_OTP_LOGIN } from './constants';

export const zillowSignIn = async (
    experiments: Record<ExperimentService.Domain.ActiveExperiment, TreatmentWithConfig | null>,
    options?: SignInOptions,
    authorizationParams?: Record<string, string>
) => {
    const fetchClient = FetchClient.getInstance();
    await DatadogRUMService.Client.getInstance().addAction(
        DatadogRUMService.CustomAction.AUTHENTICATION_START,
        undefined,
        {
            onlyLogOnce: true,
        }
    );
    const provider = ZILLOW_AUTH_PROVIDER.AUTH0;
    setSessionStorageItem(LOCATION_REQUESTED_SESSION_STORAGE_KEY, window.location.pathname);
    const signInOptions: SignInAuthorizationParams = {
        [SUPPORTED_LOGIN_FLAG]: ENABLE_OTP_LOGIN,
        ...authorizationParams,
    };
    await fetchClient
        .fetch('/homeloans/mortgage/api/auth/metrics/signin', {
            method: 'POST',
            body: {
                location: window.location.pathname,
            },
        })
        .catch(noop);
    await appendAuth0IdpIdentifier(signInOptions);
    setTimeout(() => {
        // defer sign-in long enough for the dispatch to propagate
        signIn(provider, options, signInOptions);
    }, 250);
};
